var localeRegex = /^[a-z]{2}-[A-Z]{2}$/;
export var normalizeLocale = function (_a) {
    var language = _a.language, country = _a.country;
    var normalizedLanguage = language.toLocaleLowerCase();
    var normalizedCountry = country.toLocaleUpperCase();
    var locale = "".concat(normalizedLanguage, "-").concat(normalizedCountry);
    if (!localeRegex.test(locale)) {
        throw new Error("Incorrect locale information provided for ".concat(locale));
    }
    return { language: normalizedLanguage, country: normalizedCountry };
};
//# sourceMappingURL=normalizeLocale.js.map